import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.currentUser;

export default class CurrentUser extends Model {
  static entity = `${name}`;

  static fields() {
    return {
      id: this.attr(null),
      first_name: this.string(),
      last_name: this.string(),
      username: this.string(),
      groups: this.attr([]),
    };
  }

  static methodConf = {
    http: {
      url: '/auth',
    },
    methods: {
      $fetch: {
        name: 'fetch',
        http: {
          url: '/current_user',
          method: 'get',
        },
      },
    },
  };
}
